export default () => {

  const popup = document.getElementById('building-matterport-popup');
  const iframe = document.getElementById('building-matterport-iframe');
  const closeBtn = document.getElementById('building-matterport-close-btn');
  const openBtn = document.getElementById('building-matterport-open-btn');
  // const playBtn = document.getElementById('playBtn');
  if (!popup || !iframe || !closeBtn || !openBtn) return;
  const OPENED = 'opened';
  let matterportFired = false;

  const openPopup = () => {
    // if (!matterportFired) {
    //   matterportFired = true;
    //   const src = iframe.getAttribute('data-src');
    //   iframe.setAttribute('src', src);
    //   iframe.removeAttribute('data-src');
    // }
    popup.classList.add(OPENED);
  };
  const closePopup = () => popup.classList.remove(OPENED);

  openBtn.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);

}
